import script from "./SitePreheader.vue?vue&type=script&lang=js"
export * from "./SitePreheader.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__